module.exports = __webpack_public_path__ + "img/experience05.7a2c40a0.jpg";